module.exports = __webpack_public_path__ + "static/media/eye-dropper.af55a4d7.svg";